import type { IPaymentMethodsList, TPaymentMethodsMap } from "../types/constants";

import { CreditCard } from "../assets/Icons";
import { Generic } from "../assets/Icons/partners/Generic";
import { GenericRounded } from "../assets/Icons/partners/GenericRounded";

import { Card } from "../assets/Icons/partners/Card";
import { Maal } from "../assets/Icons/partners/Maal";
import { Sympl } from "../assets/Icons/partners/Sympl";
import { Valu } from "../assets/Icons/partners/Valu";
import { Contact } from "../assets/Icons/partners/Contact";
import { Forsa } from "../assets/Icons/partners/Forsa";
import { Kiosk } from "../assets/Icons/partners/Kiosk";
import { MidTakseet } from "../assets/Icons/partners/MidTakseet";
import { Paypal } from "../assets/Icons/partners/PayPal";
import { PremiumCard } from "../assets/Icons/partners/PremiumCard";
import { Wallet } from "../assets/Icons/partners/Wallet";
import { Souhoola } from "../assets/Icons/partners/Souhoola";
import { Instapay } from "../assets/Icons/partners/Instapay";
import { BankInstallments } from "../assets/Icons/partners/BankInstallments";
import { Tamara } from "../assets/Icons/partners/Tamara";
import { Crypto } from "../assets/Icons/partners/Crypto";
import { StcPay } from "../assets/Icons/partners/StcPay";
import { Jazzcash } from "../assets/Icons/partners/JazzCash";
import { Tru } from "../assets/Icons/partners/Tru";
import { Seven } from "../assets/Icons/partners/Seven";
import { Aman } from "../assets/Icons/partners/Aman";
import { Klivvr } from "../assets/Icons/partners/Klivvr";
import { Knet } from "../assets/Icons/partners/Knet";
import { Halan } from "../assets/Icons/partners/Halan";
import { Applepay } from "../assets/Icons/partners/ApplePay";
import { PostPay } from "../assets/Icons/partners/Postpay";
import { Easypaisa } from "../assets/Icons/partners/EasyPaisa";
import { Tabby } from "../assets/Icons/partners/Tabby";
import { Googlepay } from "../assets/Icons/partners/GooglePay";
import { Mylo } from "../assets/Icons/partners/Mylo";
import { Aani } from "../assets/Icons/partners/Aani";
import { Madfu } from "../assets/Icons/partners/Madfu";

import { CardRounded } from "../assets/Icons/partners/CardRounded";
import { MaalRounded } from "../assets/Icons/partners/MaalRounded";
import { SymplRounded } from "../assets/Icons/partners/SymplRounded";
import { ValuRounded } from "../assets/Icons/partners/ValuRounded";
import { ContactRounded } from "../assets/Icons/partners/ContactRounded";
import { ForsaRounded } from "../assets/Icons/partners/ForsaRounded";
import { KioskRounded } from "../assets/Icons/partners/KioskRounded";
import { MidTakseetRounded } from "../assets/Icons/partners/MidTakseetRounded";
import { PremiumCardRounded } from "../assets/Icons/partners/PremiumCardRounded";
import { WalletRounded } from "../assets/Icons/partners/WalletRounded";
import { SouhoolaRounded } from "../assets/Icons/partners/SouhoolaRounded";
import { InstapayRounded } from "../assets/Icons/partners/InstapayRounded";
import { BankInstallmentsRounded } from "../assets/Icons/partners/BankInstallmentsRounded";
import { TamaraRounded } from "../assets/Icons/partners/TamaraRounded";
import { CryptoRounded } from "../assets/Icons/partners/CryptoRounded";
import { StcPayRounded } from "../assets/Icons/partners/StcPayRounded";
import { JazzCashRounded } from "../assets/Icons/partners/JazzCashRounded";
import { TruRounded } from "../assets/Icons/partners/TruRounded";
import { SevenRounded } from "../assets/Icons/partners/SevenRounded";
import { AmanRounded } from "../assets/Icons/partners/AmanRounded";
import { KlivvrRounded } from "../assets/Icons/partners/KlivvrRounded";
import { KnetRounded } from "../assets/Icons/partners/KNETRounded";
import { HalanRounded } from "../assets/Icons/partners/HalanRounded";
import { ApplePayRounded } from "../assets/Icons/partners/ApplePayRounded";
import { PostpayRounded } from "../assets/Icons/partners/PostpayRounded";
import { EasyPaisaRounded } from "../assets/Icons/partners/EasyPaisaRounded";
import { TabbyRounded } from "../assets/Icons/partners/TabbyRounded";
import { MyloRounded } from "../assets/Icons/partners/MyloRounded";
import { AaniRounded } from "../assets/Icons/partners/AaniRounded";
import { MadfuRounded } from "../assets/Icons/partners/MadfuRounded";

export const DEFAULT_PAYMENT_METHOD: IPaymentMethodsList = {
  name: '',
  nameAr: '',
  icon: Generic,
  iconRounded: GenericRounded,
  iconType: 'generic'
};

export const PAYMENT_METHODS_LIST: TPaymentMethodsMap = new Map(
  [
    [['Card Payment', 'MIGS'],
    {
      name: 'Card',
      nameAr: 'بطاقة بنكية',
      icon: Card,
      iconRounded: CardRounded,
      iconType: 'payment-method'
    }],
    [
      ['Oman Net', 'OMANNET', 'omannet', 'omnnet', 'Oman Net', 'Oman net', 'Omannet', 'OmanNet'],
      {
        name: 'Maal',
        nameAr: 'مال',
        icon: Maal,
        iconRounded: MaalRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['SympL', 'SYMPL'],
      {
        name: 'Sympl',
        nameAr: 'سيمبل',
        icon: Sympl,
        iconRounded: SymplRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Sympl V2', 'SYMPL_V2'],
      {
        name: 'Sympl v2',
        nameAr: 'سيمبل',
        icon: Sympl,
        iconRounded: SymplRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['valU Payment', 'VALU'],
      {
        name: 'valU',
        nameAr: 'فاليو',
        icon: Valu,
        iconRounded: ValuRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Contact', 'CONTACT'],
      {
        name: 'Contact',
        nameAr: 'كونتاكت',
        icon: Contact,
        iconRounded: ContactRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Forsa', 'Forsa V2', 'FORSA', 'FORSA_V2', 'forsa_v2'],
      {
        name: 'Forsa',
        nameAr: 'فرصة',
        icon: Forsa,
        iconRounded: ForsaRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Accept Kiosk', 'CAGG'],
      {
        name: 'Kiosk',
        nameAr: "اكسبت كيوسك",
        icon: Kiosk,
        iconRounded: KioskRounded,
        iconType: 'generic'
      }
    ],
    [
      ['Mid Takseet', 'MID_TAKSEET'],
      {
        name: 'Mid Takseet',
        nameAr: 'ميد تقسيط',
        icon: MidTakseet,
        iconRounded: MidTakseetRounded,
        iconType: 'generic'
      }
    ],
    [
      ['PAYPAL'],
      {
        name: 'PayPal',
        nameAr: 'باي بال',
        icon: Paypal,
        iconRounded: Paypal,
        iconType: 'generic'
      }
    ],
    [
      ['Premium Card', 'PREMIUM', 'PREMIUM6'],
      {
        name: 'Premium',
        nameAr: 'بريميوم',
        icon: PremiumCard,
        iconRounded: PremiumCardRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Digital Wallet'],
      {
        name: 'Digital Wallet',
        nameAr: 'محفظة رقمية',
        icon: Wallet,
        iconRounded: WalletRounded,
        iconType: 'generic'
      }
    ],
    [
      ['SOUHOOLA_V3', 'Souhoola V3', 'SOUHOOLAV3'],
      {
        name: 'Souhoola v3',
        nameAr: 'سهولة',
        icon: Souhoola,
        iconRounded: SouhoolaRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['souhoolav2', 'SOUHOOLA_V2', 'SOUHOOLAV2', 'Souhoola v2'],
      {
        name: 'Souhoola v2',
        nameAr: 'سهولة',
        icon: Souhoola,
        iconRounded: SouhoolaRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Mobile wallet', 'UIG'],
      {
        name: 'Mobile Wallet',
        nameAr: 'محفظة',
        icon: Wallet,
        iconRounded: WalletRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['InstaPay', 'INSTAPAY'],
      {
        name: 'Instapay',
        nameAr: 'إنستاباي',
        icon: Instapay,
        iconRounded: InstapayRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Bank Installments', 'INSTALLMENT'],
      {
        name: 'Bank Installments',
        nameAr: 'تقسيط بنكي',
        icon: BankInstallments,
        iconRounded: BankInstallmentsRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['TAMARA'],
      {
        name: 'Tamara',
        nameAr: 'تمارا',
        icon: Tamara,
        iconRounded: TamaraRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['CRYPTO'],
      {
        name: 'Crypto',
        nameAr: 'كريبتو',
        icon: Crypto,
        iconRounded: CryptoRounded,
        iconType: 'generic'
      }
    ],
    [
      ['STC Pay', 'STCPAY'],
      {
        name: 'STC Pay',
        nameAr: 'STC باي',
        icon: StcPay,
        iconRounded: StcPayRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['jazzcash', 'JAZZCASH'],
      {
        name: 'JazzCash',
        nameAr: 'جاز كاش',
        icon: Jazzcash,
        iconRounded: JazzCashRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['TRU'],
      {
        name: 'Tru',
        nameAr: 'ترو',
        icon: Tru,
        iconRounded: TruRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Seven', 'SEVEN'],
      {
        name: 'Seven',
        nameAr: 'سيفن',
        icon: Seven,
        iconRounded: SevenRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['AMAN V3', 'AMAN', 'AMAN_V2', 'AMANV3'],
      {
        name: 'Aman',
        nameAr: 'أمان',
        icon: Aman,
        iconRounded: AmanRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Klivvr', 'KLIVVR'],
      {
        name: 'Klivvr',
        nameAr: 'كليفر',
        icon: Klivvr,
        iconRounded: KlivvrRounded,
        iconType: 'generic'
      }
    ],
    [
      ['KNET'],
      {
        name: 'KNET',
        nameAr: 'كي نت',
        icon: Knet,
        iconRounded: KnetRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Halan', 'HALAN'],
      {
        name: 'Halan',
        nameAr: 'حالاً',
        icon: Halan,
        iconRounded: HalanRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Apple Pay', 'apple-pay'],
      {
        name: 'Apple Pay',
        nameAr: 'أبل باي',
        icon: Applepay,
        iconRounded: ApplePayRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['POSTPAY'],
      {
        name: 'Post pay',
        nameAr: 'بوست باي',
        icon: PostPay,
        iconRounded: PostpayRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['EASYPAISA', 'EASYPAISADIRECT'],
      {
        name: 'Easy paisa',
        nameAr: 'إيزي بايسا',
        icon: Easypaisa,
        iconRounded: EasyPaisaRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['TABBY'],
      {
        name: 'Tabby',
        nameAr: 'تابي',
        icon: Tabby,
        iconRounded: TabbyRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['google-pay'],
      {
        name: 'Google Pay',
        nameAr: 'جوجل باي',
        icon: Googlepay,
        iconRounded: Googlepay,
        iconType: 'payment-method'
      }
    ],

    // Generics
    [
      ['knet-apple-pay', 'Knet-apple-pay', 'KNET_APPLE_PAY'],
      {
        name: 'Knet-apple-pay',
        nameAr: 'كي نت ابل باي',
        icon: Generic,
        iconRounded: GenericRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['KNET_CARD', 'KnetCard'],
      {
        name: 'KNET Card',
        nameAr: 'KNET Card',
        icon: Generic,
        iconRounded: GenericRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['DIGITAL_WALLET'],
      {
        name: 'Digital Wallet',
        nameAr: 'محفظة رقمية',
        icon: Generic,
        iconRounded: GenericRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['VPC', 'CARDS'],
      {
        name: 'Online Card',
        nameAr: 'بطاقة ائتمان',
        icon: Generic,
        iconRounded: GenericRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['CASH'],
      {
        name: "Cash Collection",
        nameAr: "كاش عند التوصيل",
        icon: Generic,
        iconRounded: GenericRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['MPAY'],
      {
        name: "Jawwal Pay",
        nameAr: "محفظه",
        icon: Generic,
        iconRounded: GenericRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['GET_GO'],
      {
        name: "Contact Shopping",
        nameAr: "كونتكت تسوق",
        icon: Generic,
        iconRounded: GenericRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Mylo', 'MYLO'],
      {
        name: 'mylo',
        nameAr: 'ميلو',
        icon: Mylo,
        iconRounded: MyloRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['Aani', 'AANI'],
      {
        name: 'Aani',
        nameAr: 'آني',
        icon: Aani,
        iconRounded: AaniRounded,
        iconType: 'payment-method'
      }
    ],
    [
      ['MADFU', 'Madfu'],
      {
        name: 'Madfu',
        nameAr: 'مدفوع',
        icon: Madfu,
        iconRounded: MadfuRounded,
        iconType: 'payment-method'
      }
    ],
  ]
);